import { render, staticRenderFns } from "./WhereIsMyAccuralsAlfa.vue?vue&type=template&id=48701fff"
import script from "./WhereIsMyAccuralsAlfa.vue?vue&type=script&lang=js"
export * from "./WhereIsMyAccuralsAlfa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports